import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_DOCTOR_SEARCH,
    getDoctorSearchFail,
    getDoctorSearchSuccess
} from '../action/getDoctorSearchAction'

// api 
import getDoctorSearchApi from '../api/getDoctorSearchApi'

export function* getDoctorSearchSaga(action) {
    try {
        const response = yield call(() => getDoctorSearchApi(action.params))
        if (response.data.status === 1) {
            yield put(getDoctorSearchSuccess(response, action))
        } else {
            yield put(getDoctorSearchFail(response, action))
        }
    }
    catch (e) {
        yield put(getDoctorSearchFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_DOCTOR_SEARCH, getDoctorSearchSaga)
}